var MobileMenu = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('mobile-menu');
    this.overlay = document.querySelector('.page-overlay');

    // this.openButtons = document.querySelectorAll('.js-open-menu');

     this.trigger = document.querySelector('.mobile-menu-trigger');

    this.closeButtons = document.querySelectorAll('.js-close-menu');

    this.dropdownButtons = this.querySelectorAll('.dropdown-button');
    
    this.drawer.addEventListener('keydown', (evt) => evt.code === 'Escape' && this.close());
    this.bindEvents();
  }

  bindEvents() {
    // this.openButtons.forEach(button => button.addEventListener('click', this.open.bind(this)));
    this.trigger.addEventListener('click', event => {
      this.trigger.classList.contains('open') ? this.close() : this.open();
    });
    this.closeButtons.forEach(button => button.addEventListener('click', this.close.bind(this)));
    this.dropdownButtons.forEach(dropdownBtn => dropdownBtn.addEventListener('click', this.handleButtonClick.bind(this)));
  }

  open() {
    if(this.drawer.getAttribute('aria-hidden') == 'false') {
      this.close()
      return
    }
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    // this.overlay.classList.remove('invisible', 'opacity-0');
    // this.overlay.addEventListener('click', event => {
    //   this.close();
    // });

    document.body.classList.add('overflow-hidden');
    document.body.setAttribute('data-menu-open', true)
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    // this.overlay.classList.add('invisible', 'opacity-0');

    document.body.classList.remove('overflow-hidden');
    document.body.removeAttribute('data-menu-open')
  }

  handleButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const dropdown = button.nextElementSibling;

    if (button.classList.contains('active')) {
      button.classList.remove('active');
      slideUp(dropdown, 300);
    } else {
      button.classList.add('active');
      slideDown(dropdown, 300);
    }
  }
}

customElements.define('mobile-menu', MobileMenu);